/**
 * Mixin for QSelect wrappers whose picker opens as a full-screen dialog on phones.
 *
 * QSelect's dialog has no way to close itself, its clearable icon clears the model
 * (not the search term) and the keyboard's Done key does nothing. The component
 * renders a Done and a clear-search button in the `append` slot (both only shown
 * inside the dialog, see styleoverrides.scss) and wires them up here. Needs
 * `ref="select"` on the QSelect and `@input-value="onSearchInput"`.
 */
export default {
  data () {
    return {
      searchTerm: ''
    }
  },
  computed: {
    dialogBehaviour () {
      return this.$q.screen.lt.md
    }
  },
  methods: {
    onSearchInput (val) {
      this.searchTerm = val
    },
    clearSearch () {
      if (!this.$refs.select) {
        return
      }
      // Focus first: QSelect only re-runs the filter while the field is focused,
      // and this keeps the keyboard up for the next search.
      this.$refs.select.focus()
      this.$refs.select.updateInputValue('')
    },
    closePopup () {
      if (!this.$refs.select) {
        return
      }
      this.$refs.select.hidePopup()
      // QDialog hands focus back to the page field as it closes, which would keep
      // the keyboard up; drop it so Done dismisses the keyboard as well.
      this.$nextTick(() => {
        if (this.$refs.select) {
          this.$refs.select.blur()
        }
      })
    },
    onEnterKey () {
      // QSelect never closes its dialog picker on Enter (and re-opens it if nothing
      // is open once its own handler runs), so the keyboard's Done key closes it
      // here, after that handler.
      if (this.dialogBehaviour) {
        this.$nextTick(this.closePopup)
      }
    }
  }
}
